import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Stack,
  Link,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { endpoint } from "../../resource/Constant";
import { useSnackbar } from "notistack";
import Header from "./Header";

const SignUp = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: "success" | "error" | "info" }>({
    open: false,
    message: "",
    severity: "info",
  });
  const [loading , setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (message: string, severity: "success" | "error" | "info") => {
    enqueueSnackbar(message, { variant: severity });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    if (password !== confirm) {
      showSnackbar("Passwords do not match. Please re-enter.", "error");
      return;
    }
    axios.post(`${endpoint}/api/crawling/signup` , {
      company_name : name,
      email : email,
      password : password,
      confirmpassword : confirm
    })
    .then((res) => {
      setLoading(false);
      console.log(res)
      showSnackbar(res?.data?.message || "Account created successfully. You can now sign in.", "success");
      navigate('/crawling/signin')
    })
    .catch((error) => {
      showSnackbar(error?.response?.data?.message || "Unable to sign up right now. Please try again.", "error");
    })
  };

  return (
    <>
    <Header />
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background glows */}
      <Box
        sx={{
          position: "absolute",
          top: 80,
          left: 80,
          width: 360,
          height: 360,
          bgcolor: "primary.main",
          opacity: 0.25,
          borderRadius: "50%",
          filter: "blur(60px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 80,
          right: 80,
          width: 360,
          height: 360,
          bgcolor: "success.main",
          opacity: 0.25,
          borderRadius: "50%",
          filter: "blur(60px)",
        }}
      />

      <Card
        sx={{
          width: "100%",
          maxWidth: 520,
          boxShadow: 8,
          border: "2px solid",
          borderColor: "primary.main",
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(10px)",
          position: "relative",
          zIndex: 1,
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Box textAlign="center">
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  background: "linear-gradient(135deg, #1976d2, #66bb6a)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Create Account
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Sign up to configure and manage your chatbot.
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                <TextField
                  label="Full Name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                />
                <TextField
                  label="Email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  label="Password"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  label="Confirm Password"
                  type="password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  fullWidth
                />
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{
                    background: "linear-gradient(135deg, #1976d2, #42a5f5, #66bb6a)",
                    fontWeight: 600,
                    "&:hover": {
                      background: "linear-gradient(135deg, #1565c0, #1976d2, #42a5f5)",
                      boxShadow: 8,
                    },
                  }}
                >
                  Sign Up
                </Button>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Link component="button" variant="body2" onClick={() => navigate("/crawling/signin")}>
                    Already have an account? Sign In
                  </Link>
                </Stack>
              </Stack>
            </form>
          </Stack>
        </CardContent>
      </Card>
    </Box>
    </>
  );
};

export default SignUp;

